import React from 'react';
import './App.css';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { authentication } from 'components/user-access';

import { MainLayout } from 'pages/layouts/MainLayout';
import { DriverRegistration } from 'pages/register/driver';
import { UserConfirm } from 'pages/register/confirm';
import { ForgotPasswordRequest, ForgotPasswordConfirm } from 'pages/forgot-password';
import { ValidateEmail, ValidateExternalUserEmail } from 'pages/validate-email';
import { LicenceCheckingConsent } from 'pages/licence-checking/consent';
import { DebriefSignOff } from 'pages/debrief-sign-off';
import { EmployeeAssessmentsTrainingLaunch, trainingLaunchRoutePath } from 'pages/employee-assessments/training-launch';
import { GreyFleetInsuranceDetails } from 'pages/licence-checking/grey-fleet/insurance-details';
import { Referrer } from 'pages/referrer/Referrer';
import { PaymentRedirectPage, PaymentSuccessPage, PaymentFailedPage } from 'pages/payments';
import { ReviewSignOff } from 'pages/review-sign-off';

var AnonymousDriverRegistration = authentication.anonymousAccess(DriverRegistration);
var AnonymousUserConfirm = authentication.anonymousAccess(UserConfirm);
var AnonymousValidateEmail = authentication.anonymousAccess(ValidateEmail);
var AnonymousValidateExternalUserEmail = authentication.anonymousAccess(ValidateExternalUserEmail);
var AnonymousForgotPasswordConfirm = authentication.anonymousAccess(ForgotPasswordConfirm);
var AnonymousForgotPasswordRequest = authentication.anonymousAccess(ForgotPasswordRequest);
var AuthenticatedMainLayout = authentication.required(MainLayout);

// Exported so tests can assert how a route is registered - which component, and whether it is
// wrapped - without standing the whole application up.
export const routes = [
    { path: "/register/driver", element: <AnonymousDriverRegistration /> },
    { path: "/register/confirm", element: <AnonymousUserConfirm /> },
    { path: "/validate-email", element: <AnonymousValidateEmail /> },
    { path: "/Validate-external-user-email", element: <AnonymousValidateExternalUserEmail /> },
    { path: "/forgot-password/confirm", element: <AnonymousForgotPasswordConfirm /> },
    { path: "/forgot-password", element: <AnonymousForgotPasswordRequest /> },
    { path: "/licence-checking-declaration", element: <LicenceCheckingConsent /> },
    { path: "/grey-fleet-insurance-details", element: <GreyFleetInsuranceDetails /> },
    { path: "/debrief-sign-off", element: <DebriefSignOff /> },
    // Deliberately NOT wrapped in authentication.anonymousAccess: that helper sends an already
    // signed-in user to the home page, which would break the emailed link for any driver with a
    // live Vision session in the same browser.
    { path: trainingLaunchRoutePath, element: <EmployeeAssessmentsTrainingLaunch /> },
    { path: "/review-sign-off", element: <ReviewSignOff /> },
    { path: "/referral/:code", element: <Referrer /> },
    { path: "/payments/redirect", element: <PaymentRedirectPage /> },
    { path: "/payments/success", element: <PaymentSuccessPage /> },
    { path: "/payments/failed", element: <PaymentFailedPage /> },
    { path: "*", element: <AuthenticatedMainLayout /> }
];

const router = createBrowserRouter(routes);

function App() {
    return <RouterProvider router={router} />;
}

export default App;
